import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SimpleAuthCard from './SimpleAuthCard.jsx'
import Button from '../../components/ui/Button.jsx'
import { Field, Input } from '../../components/ui/Field.jsx'
import Icon from '../../components/ui/Icon.jsx'
import api from '../../lib/api.js'

/* Request a password-reset email — inventory §2. Backend always 200 (no user
 * enumeration); on success we show a "check your inbox" panel. */
export default function ForgotPasswordPage() {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const submit = async (e) => {
    e.preventDefault()
    setError(''); setLoading(true)
    try { await api.post('/auth/forgot-password', { email }); setSent(true) }
    catch { setError(t('auth.forgot.error')) }
    finally { setLoading(false) }
  }

  if (sent) {
    return (
      <SimpleAuthCard title={t('auth.forgot.successTitle')}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: 52, height: 52, borderRadius: '50%', background: 'var(--color-success-bg)', color: 'var(--color-success)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' }}><Icon name="mail" size={26} /></div>
          <p style={{ color: 'var(--color-text)', fontSize: 14 }}>{t('auth.forgot.successMessage')}</p>
        </div>
      </SimpleAuthCard>
    )
  }

  return (
    <SimpleAuthCard title={t('auth.forgot.title')} subtitle={t('auth.forgot.subtitle')}>
      {error && <div role="alert" style={{ background: 'var(--color-danger-bg)', color: 'var(--color-danger)', border: '1px solid #f3c9c9', borderRadius: 10, padding: '10px 13px', fontSize: 13, marginBottom: 16 }}>{error}</div>}
      <form onSubmit={submit}>
        <Field label={t('auth.login.email')}><Input type="email" required autoFocus value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@societe.be" /></Field>
        <Button type="submit" variant="primary" icon="mail" fullWidth loading={loading}>{t('auth.forgot.submit')}</Button>
      </form>
    </SimpleAuthCard>
  )
}
